/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Zakelijke telefoon',
  [phoneTypes.extension]: 'Extensienummer',
  [phoneTypes.home]: 'Privénummer',
  [phoneTypes.mobile]: 'Mobiele telefoon',
  [phoneTypes.phone]: 'Telefoon',
  [phoneTypes.unknown]: 'Onbekend telefoontype',
  [phoneTypes.company]: 'Bedrijfsnummer',
  [phoneTypes.direct]: 'Direct nummer',
  [phoneTypes.contact]: 'Telefoon contactpersoon',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Overig',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
